import { HTTP } from '../../services';
import { GenericApiBaseURL} from '../../environment';

import { HTTPService } from './API.services';

const httpService = new HTTPService(HTTP, GenericApiBaseURL)

const servicesList =  {
    httpService
}

export default servicesList;

